import classNames from 'classnames'

import { IS_STORYBOOK } from 'shared/consts/env'
import {
  addDpiSrcsets,
  addSizeToImageSrc,
  getWebpSrc,
  getWebpSrcSet,
} from 'shared/utils/imageUtils'
import { usePublicConfig } from 'views/utils/shopAndRuntimeConfigUtils'

export const mapPropsToImgProps = ({
  imageAttrs,
  className,
  src,
  width,
  height,
  srcWidth,
  srcHeight,
  lazyLoad,
  clientsideHook,
  title,
}) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks -- TODO This function uses a hook, so is also a hook and should be renamed to `use…`
  const { cdnUrl } = usePublicConfig()
  const imgProps = {
    ...imageAttrs,
    width: src?.width || width,
    height: src?.height || height,
    className: classNames(className) || null,
    'data-clientside-hook': clientsideHook || null,
  }

  const source = srcWidth
    ? addSizeToImageSrc({
        src,
        width: srcWidth,
        height: srcHeight,
        cdnUrl,
      })
    : src
  const sourceSet = srcWidth ? addDpiSrcsets({ src: source, cdnUrl }) : null

  imgProps.src = source
  imgProps.srcSet = sourceSet

  if (lazyLoad && !IS_STORYBOOK) {
    imgProps.loading = 'lazy'
  }
  if (title) {
    imgProps.title = title
  }

  return imgProps
}

export const getSourceProps = (imgProps, cdnUrl) => {
  const src = imgProps['data-src'] || imgProps.src

  let srcSet = imgProps['data-srcSet'] || imgProps.srcSet
  if (!srcSet) {
    srcSet = addDpiSrcsets({ src, cdnUrl })
  }

  return { src, srcSet }
}

export const getSrcSets = ({ src, srcSet, srcMobile, cdnUrl }) => {
  const webpSrcSet =
    srcSet === src
      ? getWebpSrc({
          cdnUrl,
          src,
        })
      : getWebpSrcSet({
          cdnUrl,
          srcSet,
        })

  const mobileSrcSet = !srcMobile
    ? null
    : addDpiSrcsets({ src: srcMobile, cdnUrl })

  const mobileWebpSrcSet = getWebpSrcSet({
    srcSet: mobileSrcSet || webpSrcSet,
    cdnUrl,
  })

  return { webpSrcSet, mobileSrcSet, mobileWebpSrcSet }
}
